<template>
    <div>
        <hts-form-autocomplete
            v-model="remoocId"
            :label="$t('labels.vehicleModule.pluginName')"
            :required="props.required"
            :server="serverRemooc"
            :text="remoocName"
            :placeholder="$t('labels.remoocModule.select')"
            :add="false"
            key-id="_id"
            key-label="name"
            @change="(data:any)=>handleChange(data)" />
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  required: {
    type: Boolean,
    default: true
  },
  remoocIsSelected: {
    type: String,
    default: ''
  }
})
const remoocId = ref('')
const remoocName = ref('')
const serverRemooc = $urlPartner.vehicle.remooc.find
const emits = defineEmits(['changeInput'])

onMounted(() => {
  if (props.remoocIsSelected) {
    remoocName.value = props.remoocIsSelected
  } else {
    remoocName.value = ''
  }
})

const handleChange = (data: any) => {
  emits('changeInput', data)
}
</script>
